import { Flex, Typography } from "antd";
import { FONT_CATEGORIES, FontCategory, FontItem } from "../types";
import { FontFamilyCollapse } from "./FontFamilyCollapse";

interface FontCategorySectionProps {
  category: FontCategory;
  expandedFamilies: Set<string>;
  selectedFont?: string;
  selectedBackgroundColor: string;
  onFontSelect: (fontItem: FontItem) => void;
  onFamilyToggle: (familyName: string, keys: string[]) => void;
  assetLibraryId: string;
  onFontDeleteSuccess?: (fontItemId: string) => void;
}

export const FontCategorySection = ({
  category,
  expandedFamilies,
  selectedFont,
  selectedBackgroundColor,
  onFontSelect,
  onFamilyToggle,
  assetLibraryId,
  onFontDeleteSuccess,
}: FontCategorySectionProps) => {
  const renderBrandkitAndCatalogFonts = () => {
    return category.families.map((family) => {
      const id = `${category.categoryType}-${family.familyName}`;
      return (
        <FontFamilyCollapse
          key={id}
          id={id}
          family={family}
          isExpanded={expandedFamilies.has(id)}
          onToggle={onFamilyToggle}
          selectedFont={selectedFont}
          selectedBackgroundColor={selectedBackgroundColor}
          onFontSelect={onFontSelect}
          assetLibraryId={assetLibraryId}
          allowDelete={
            category.categoryType === FONT_CATEGORIES.LIBRARY_FONTS &&
            selectedFont !== family.representativeVariant?.key
          }
          onDeleteSuccess={onFontDeleteSuccess}
        />
      );
    });
  };

  return (
    <>
      <Flex
        align="center"
        style={{
          padding: "0 0 16px 0",
          width: "100%",
        }}
        gap={8}
      >
        {category.icon}
        <Typography.Text strong style={{ fontSize: 14 }}>
          {category.categoryName}
        </Typography.Text>
      </Flex>
      {renderBrandkitAndCatalogFonts()}
    </>
  );
};
